import { render } from "./footer.vue?vue&type=template&id=1ff6f2ea&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=1ff6f2ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/simuam/simuam/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff6f2ea"]])

export default __exports__